import { observer } from 'mobx-react';
import SegmentStore from '../../../SegmentStore';
import { QuizResult } from '../../../SegmentStore/Types';
import { T } from '../../../Translations';

interface Props {
  store: SegmentStore;
  quizResult: QuizResult;
}

function QuizFailureNotice({ store, quizResult }: Props) {
  return (
    <div className="p-6 text-center" data-intercom-target="quiz-failure-notice-section">
      <p className="mb-2">
        <T kind="You scored {{score}}%." score={quizResult.score} />{' '}
        <T kind="You need {{passingScore}}% to pass." passingScore={quizResult.passingScore} />
      </p>
      <p className="mb-4">
        <T kind="Attempt {{count}}" count={quizResult.attempts} />
      </p>
      <button
        className="rounded-md bg-green-600 px-6 py-2 text-white transition-colors hover:bg-green-700"
        onClick={() => store.retryQuiz()}
        data-intercom-target="quiz-retry-button"
      >
        <T kind="Try again" />
      </button>
    </div>
  );
}

export default observer(QuizFailureNotice);
